import { render, staticRenderFns } from "./WTabs.vue?vue&type=template&id=08da218a&scoped=true&"
import script from "./wTabs.ts?vue&type=script&lang=ts&"
export * from "./wTabs.ts?vue&type=script&lang=ts&"
import style0 from "./WTabs.vue?vue&type=style&index=0&id=08da218a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da218a",
  null
  
)

export default component.exports